import { render, staticRenderFns } from "./ProjectMixin.vue?vue&type=template&id=799b5c65&scoped=true"
import script from "./ProjectMixin.vue?vue&type=script&lang=js"
export * from "./ProjectMixin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "799b5c65",
  null
  
)

export default component.exports